// @flow

import { render as userDropdownRender } from "./renderer";

(function(root) {
	root.__reece_render_header__ = function() {
		userDropdownRender();
	};
})(window);
